export const SET_MODEL = 'SET_MODEL';
export const RESET_PHONES = 'RESET_PHONES';
export const SET_QUESTIONS = 'SET_QUESTIONS';
export const RESET_QUESTINS = 'RESET_QUESTINS';
export const ADD_ANSWER = 'ADD_ANSWER';
export const SET_PRICE = 'SET_PRICE';
export const SET_SUBSIDIES = 'SET_SUBSIDIES';
export const SET_OURDISCOUNT = 'SET_OURDISCOUNT';
export const SET_CHOOSESUBSIDIES = 'SET_CHOOSESUBSIDIES';
export const SET_SCORRING = 'SET_SCORRING';
export const SET_MANUAL = 'SET_MANUAL';
export const SET_MANUALDATA = 'SET_MANUALDATA';
export const SET_GRADE = 'SET_GRADE';
export const SET_REFUSALS = 'SET_REFUSALS';
export const SET_NUMBER = 'SET_NUMBER';
export const SET_LOADING = 'SET_LOADING';
export const SET_CALCULATION = 'SET_CALCULATION';
export const SET_ERROR = 'SET_ERROR';
export const SET_SCORRING_POPUP = 'SET_SCORRING_POPUP';
export const SET_ERROR_SEARCH = 'SET_ERROR_SEARCH';
export const CHANGE_SCREEN_THREE = 'CHANGE_SCREEN_THREE';
export const CHANGE_CLIENT_INFO = 'CHANGE_CLIENT_INFO';
export const SET_ORDER = 'SET_ORDER';
export const SET_DISCOUNTS = 'SET_DISCOUNTS';
export const CLEAR_DISCOUNT = 'CLEAR_DISCOUNT';
export const SELECT_DISCOUNT = 'SELECT_DISCOUNT';
export const SET_NEWPRICE = 'SET_NEWPRICE';
export const SET_DEFINE_MODEL_BY_IMEI = 'SET_DEFINE_MODEL_BY_IMEI';
export const SET_DEVICE_LIST = 'SET_DEVICE_LIST';
export const SET_MODEL_IMEI = 'SET_MODEL_IMEI';
export const SET_MODELS_LIST = 'SET_MODELS_LIST';
export const SET_STORAGES_LIST = 'SET_STORAGES_LIST';
export const SET_LOADER = 'SET_LOADER';
export const SET_ANSWERS = 'SET_ANSWERS';
export const SET_PHONENUMBER = 'SET_PHONENUMBER';
export const SET_DEVICEID_SECOND = 'SET_DEVICEID_SECOND';
export const SET_PRELIMINARY = 'SET_PRELIMINARY';
export const SET_FINAL_ASSESSMENT = 'SET_FINAL_ASSESSMENT';
export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS';
export const SET_SKIP_INFO_MODEL = 'SET_SKIP_INFO_MODEL';
export const SET_ASSESSMENT = 'SET_ASSESSMENT';
export const SET_ASSESSMENT_OUTCOME = 'SET_ASSESSMENT_OUTCOME';

export const SET_DEAL = 'SET_DEAL';
export const SET_ACTIVE_ORDER = 'SET_ACTIVE_ORDER';
